import {FormsySchema, TaxSchemaKeys} from '.';
import {mobileNumberRegex} from 'epic-diesel-form/src/constants/Regex';
import {
    INVALID_STR_REGEX,
    ZIP_CODE_REGEX,
    ENGLISH_ONLY_REGEX
} from '../../../shared/constants/regex';

const getTaxSchema = (getMessage, messages): FormsySchema<TaxSchemaKeys> => ({
    firstName: {
        identifier: 'firstName',
        validations: {
            maxLength: 32
        },
        validationMessages: {
            isDefaultRequiredValue: getMessage(
                messages,
                'errors.com.epicgames.validation.required_field.v2'
            ),
            maxLength: getMessage(messages, 'errors.com.epicgames.validation.max_length', [32])
        },
        display: {
            text: getMessage(messages, 'epic.affiliate.signup.guardian.first.name')
        }
    },
    lastName: {
        identifier: 'lastName',
        validations: {
            maxLength: 32
        },
        validationMessages: {
            isDefaultRequiredValue: getMessage(
                messages,
                'errors.com.epicgames.validation.required_field.v2'
            ),
            maxLength: getMessage(messages, 'errors.com.epicgames.validation.max_length', [32])
        },
        display: {
            text: getMessage(messages, 'epic.affiliate.signup.guardian.last.name')
        }
    },
    guardianFirstName: {
        identifier: 'guardianFirstName',
        validations: {
            maxLength: 32
        },
        validationMessages: {
            isDefaultRequiredValue: getMessage(
                messages,
                'errors.com.epicgames.validation.required_field.v2'
            ),
            maxLength: getMessage(messages, 'errors.com.epicgames.validation.max_length', [32])
        },
        display: {
            text: getMessage(messages, 'epic.affiliate.form.tax.guardian.first.name')
        }
    },
    guardianLastName: {
        identifier: 'guardianLastName',
        validations: {
            maxLength: 32
        },
        validationMessages: {
            isDefaultRequiredValue: getMessage(
                messages,
                'errors.com.epicgames.validation.required_field.v2'
            ),
            maxLength: getMessage(messages, 'errors.com.epicgames.validation.max_length', [32])
        },
        display: {
            text: getMessage(messages, 'epic.affiliate.form.tax.guardian.last.name')
        }
    },
    foreignTax: {
        identifier: 'foreignTax',
        validationMessages: {
            isDefaultRequiredValue: getMessage(
                messages,
                'errors.com.epicgames.validation.required_field.v2'
            )
        },
        display: {
            text: getMessage(messages, 'label.affiliate.form.tax.foreignTax'),
            default: getMessage(messages, 'label.common.yes')
        }
    },
    taxType: {
        identifier: 'taxType',
        validationMessages: {
            isDefaultRequiredValue: getMessage(
                messages,
                'errors.com.epicgames.validation.required_field.v2'
            )
        },
        display: {
            text: getMessage(messages, 'label.affiliate.form.tax.taxType')
        }
    },
    organizationId: {
        identifier: 'organizationId',
        display: {
            text: getMessage(messages, 'label.affiliate.form.tax.organization.id')
        }
    },
    email: {
        identifier: 'email',
        display: {
            text: getMessage(messages, 'ui.profile.tax.email')
        }
    },
    phoneNumberWithMask: {
        identifier: 'phoneNumber',
        validations: {
            maxLength: 17
        },
        validationMessages: {
            maxLength: getMessage(messages, 'errors.com.epicgames.validation.max_length', [17]),
            isDefaultRequiredValue: getMessage(
                messages,
                'errors.com.epicgames.validation.required_field.v2'
            )
        },
        display: {
            text: getMessage(messages, 'epic.affiliate.social.phone_number')
        }
    },
    phoneNumber: {
        identifier: 'phoneNumber',
        validations: {
            maxLength: 17,
            matchRegexp: mobileNumberRegex
        },
        validationMessages: {
            maxLength: getMessage(messages, 'errors.com.epicgames.validation.max_length', [17]),
            isDefaultRequiredValue: getMessage(
                messages,
                'errors.com.epicgames.validation.required_field.v2'
            ),
            matchRegexp: getMessage(messages, 'errors.com.epicgames.validation.invalid', [
                `${getMessage(messages, 'epic.affiliate.social.phone_number')}`
            ])
        },
        display: {
            text: getMessage(messages, 'epic.affiliate.social.phone_number')
        }
    },
    paymentAmount: {
        identifier: 'paymentAmount',
        validationMessages: {
            isDefaultRequiredValue: getMessage(
                messages,
                'errors.com.epicgames.validation.required_field.v2'
            )
        },
        display: {
            text: getMessage(messages, 'label.affiliate.form.tax.payment.amount')
        }
    },
    accountId: {
        identifier: 'accountId',
        display: {
            text: getMessage(messages, 'label.affiliate.form.tax.account.id')
        }
    },
    recordIdentityKey: {
        identifier: 'recordIdentityKey',
        display: {
            text: getMessage(messages, 'label.affiliate.form.tax.id')
        }
    },
    businessType: {
        identifier: 'businessType',
        validationMessages: {
            isDefaultRequiredValue: getMessage(
                messages,
                'errors.com.epicgames.validation.required_field.v2'
            )
        },
        display: {
            text: getMessage(messages, 'label.affiliate.form.tax.businessType')
        }
    },
    guardianEmail: {
        identifier: 'guardianEmail',
        validations: {
            isEmail: true
        },
        validationMessages: {
            isDefaultRequiredValue: getMessage(
                messages,
                'errors.com.epicgames.validation.required_field.v2'
            ),
            isEmail: getMessage(messages, 'errors.com.epicgames.validation.invalid', ['email'])
        },
        display: {
            text: getMessage(messages, 'epic.affiliate.form.tax.guardian.email')
        }
    },
    guardianPhoneNumber: {
        identifier: 'guardianPhoneNumber',
        validations: {
            maxLength: 17
        },
        validationMessages: {
            maxLength: getMessage(messages, 'errors.com.epicgames.validation.max_length', [17])
        },
        display: {
            text: getMessage(messages, 'epic.affiliate.form.tax.guardian.phone')
        }
    },
    city: {
        identifier: 'city',
        validations: {
            maxLength: 32
        },
        validationMessages: {
            isDefaultRequiredValue: getMessage(
                messages,
                'errors.com.epicgames.validation.required_field.v2'
            ),
            maxLength: getMessage(messages, 'errors.com.epicgames.validation.max_length', [32])
        },
        display: {
            text: getMessage(messages, 'label.affiliate.form.tax.city')
        }
    },
    zip: {
        identifier: 'zip',
        validations: {
            maxLength: 32,
            matchRegexp: ZIP_CODE_REGEX
        },
        validationMessages: {
            isDefaultRequiredValue: getMessage(
                messages,
                'errors.com.epicgames.validation.required_field.v2'
            ),
            maxLength: getMessage(messages, 'errors.com.epicgames.validation.max_length', [32]),
            matchRegexp: getMessage(messages, 'errors.com.epicgames.validation.invalid', [
                `${getMessage(messages, 'label.affiliate.form.tax.zip')}`
            ])
        },
        display: {
            text: getMessage(messages, 'label.affiliate.form.tax.zip')
        }
    },
    country: {
        identifier: 'country',
        display: {
            text: getMessage(messages, 'label.affiliate.form.tax.Country')
        }
    },
    businessName: {
        identifier: 'businessName',
        display: {
            text: getMessage(messages, 'label.affiliate.form.tax.businessName')
        }
    },
    nameOnTaxId: {
        identifier: 'legalName',
        validationMessages: {
            isDefaultRequiredValue: getMessage(
                messages,
                'errors.com.epicgames.validation.required_field.v2'
            )
        },
        display: {
            text: getMessage(messages, 'label.affiliate.form.tax.nameOnTaxId')
        }
    },
    address: {
        identifier: 'street',
        validations: {
            maxLength: 128
        },
        validationMessages: {
            isDefaultRequiredValue: getMessage(
                messages,
                'errors.com.epicgames.validation.required_field.v2'
            ),
            maxLength: getMessage(messages, 'placeholder.localization.title')
        },
        display: {
            text: getMessage(messages, 'label.affiliate.form.tax.address')
        }
    },
    addressCityWithMask: {
        identifier: 'addressCity',
        validations: {
            maxLength: 32
        },
        validationMessages: {
            isDefaultRequiredValue: getMessage(
                messages,
                'errors.com.epicgames.validation.required_field.v2'
            ),
            maxLength: getMessage(messages, 'errors.com.epicgames.validation.max_length', [32])
        },
        display: {
            text: getMessage(messages, 'label.affiliate.form.tax.city')
        }
    },
    addressCity: {
        identifier: 'addressCity',
        validations: {
            matchRegexp: INVALID_STR_REGEX,
            maxLength: 32
        },
        validationMessages: {
            isDefaultRequiredValue: getMessage(
                messages,
                'errors.com.epicgames.validation.required_field.v2'
            ),
            maxLength: getMessage(messages, 'errors.com.epicgames.validation.max_length', [32]),
            matchRegexp: getMessage(messages, 'errors.com.epicgames.validation.invalid', [
                `${getMessage(messages, 'label.affiliate.form.tax.city')}`
            ])
        },
        display: {
            text: getMessage(messages, 'label.affiliate.form.tax.city')
        }
    },
    addressPostCodeWithMask: {
        identifier: 'addressPostCode',
        validations: {},
        validationMessages: {},
        display: {
            text: getMessage(messages, 'label.affiliate.form.tax.zip')
        }
    },
    addressPostCode: {
        identifier: 'addressPostCode',
        validations: {
            maxLength: 32,
            matchRegexp: ZIP_CODE_REGEX
        },
        validationMessages: {
            isDefaultRequiredValue: getMessage(
                messages,
                'errors.com.epicgames.validation.required_field.v2'
            ),
            maxLength: getMessage(messages, 'errors.com.epicgames.validation.max_length', [32]),
            matchRegexp: getMessage(messages, 'errors.com.epicgames.validation.invalid', [
                `${getMessage(messages, 'label.affiliate.form.tax.zip')}`
            ])
        },
        display: {
            text: getMessage(messages, 'label.affiliate.form.tax.zip')
        }
    },
    addressState: {
        identifier: 'addressState',
        validationMessages: {
            isDefaultRequiredValue: getMessage(
                messages,
                'errors.com.epicgames.validation.required_field.v2'
            )
        },
        display: {
            text: getMessage(messages, 'label.affiliate.form.tax.state')
        }
    },
    addressCountryCodeWithMask: {
        identifier: 'addressCountryCode',
        display: {
            text: getMessage(messages, 'label.affiliate.form.tax.Country')
        }
    },
    addressCountryCode: {
        identifier: 'addressCountryCode',
        validations: {
            matchRegexp: INVALID_STR_REGEX
        },
        validationMessages: {
            matchRegexp: getMessage(messages, 'errors.com.epicgames.validation.invalid', [
                `${getMessage(messages, 'label.affiliate.form.tax.addressLine1')}`
            ])
        },
        display: {
            text: getMessage(messages, 'label.affiliate.form.tax.Country')
        }
    },
    addressLine1WithMask: {
        identifier: 'addressLine1',
        display: {
            text: getMessage(messages, 'label.affiliate.form.tax.addressLine1')
        }
    },
    addressLine1: {
        identifier: 'addressLine1',
        validations: {
            matchRegexp: INVALID_STR_REGEX
        },
        validationMessages: {
            isDefaultRequiredValue: getMessage(
                messages,
                'errors.com.epicgames.validation.required_field.v2'
            ),
            matchRegexp: getMessage(messages, 'errors.com.epicgames.validation.invalid', [
                `${getMessage(messages, 'label.affiliate.form.tax.addressLine1')}`
            ])
        },
        display: {
            text: getMessage(messages, 'label.affiliate.form.tax.addressLine1')
        }
    },
    addressLine2WithMask: {
        identifier: 'addressLine2',
        display: {
            text: getMessage(messages, 'label.affiliate.form.tax.addressLine2')
        }
    },
    addressLine2: {
        identifier: 'addressLine2',
        validations: {
            matchRegexp: INVALID_STR_REGEX
        },
        validationMessages: {
            matchRegexp: getMessage(messages, 'errors.com.epicgames.validation.invalid', [
                `${getMessage(messages, 'label.affiliate.form.tax.addressLine2')}`
            ])
        },
        display: {
            text: getMessage(messages, 'label.affiliate.form.tax.addressLine2')
        }
    },
    SSN: {
        identifier: 'taxId',
        validations: {
            isValidSSN: true
        },
        validationMessages: {
            isDefaultRequiredValue: getMessage(
                messages,
                'errors.com.epicgames.validation.required_field.v2'
            ),
            isValidSSN: getMessage(messages, 'errors.com.epicgames.validation.invalid', [
                `${getMessage(messages, 'placeholder.tax.taxId.SSN')}`
            ])
        },
        display: {
            text: getMessage(messages, 'label.affiliate.form.tax.ssn'),
            placeholder: getMessage(messages, 'placeholder.tax.taxId.SSN')
        }
    },
    EIN: {
        identifier: 'taxId',
        validations: {
            maxLength: 128,
            minLength: 9
        },
        validationMessages: {
            isDefaultRequiredValue: getMessage(
                messages,
                'errors.com.epicgames.validation.required_field.v2'
            ),
            maxLength: getMessage(messages, 'errors.com.epicgames.validation.max_length', [128]),
            minLength: getMessage(messages, 'errors.com.epicgames.validation.min_length', [9])
        },
        display: {
            text: getMessage(messages, 'label.affiliate.form.tax.ein'),
            placeholder: getMessage(messages, 'placeholder.tax.taxId.EIN')
        }
    },
    VAT: {
        identifier: 'taxId',
        validations: {
            maxLength: 128,
            matchRegexp: ENGLISH_ONLY_REGEX
        },
        validationMessages: {
            isDefaultRequiredValue: getMessage(
                messages,
                'errors.com.epicgames.validation.required_field.v2'
            ),
            maxLength: getMessage(messages, 'errors.com.epicgames.validation.max_length', [128]),
            matchRegexp: getMessage(messages, 'errors.com.epicgames.validation.invalid', [
                `${getMessage(messages, 'placeholder.tax.taxId.VAT')}`
            ])
        },
        display: {
            text: getMessage(messages, 'label.affiliate.form.tax.vat'),
            placeholder: getMessage(messages, 'placeholder.tax.taxId.VAT')
        }
    },
    TAXID: {
        identifier: 'taxId',
        validations: {
            maxLength: 128,
            matchRegexp: ENGLISH_ONLY_REGEX
        },
        validationMessages: {
            isDefaultRequiredValue: getMessage(
                messages,
                'errors.com.epicgames.validation.required_field.v2'
            ),
            maxLength: getMessage(messages, 'errors.com.epicgames.validation.max_length', [128]),
            matchRegexp: getMessage(messages, 'errors.com.epicgames.validation.invalid', [
                `${getMessage(messages, 'label.affiliate.form.tax.id')}`
            ])
        },
        display: {
            text: getMessage(messages, 'label.affiliate.form.tax.id'),
            placeholder: getMessage(messages, 'label.affiliate.form.tax.id')
        }
    },
    region: {
        identifier: 'state',
        validations: {
            maxLength: 32
        },
        validationMessages: {
            isDefaultRequiredValue: getMessage(
                messages,
                'errors.com.epicgames.validation.required_field.v2'
            ),
            maxLength: getMessage(messages, 'errors.com.epicgames.validation.max_length', [32])
        },
        display: {
            text: getMessage(messages, 'ui.profile.address.form.region'),
            textState: getMessage(messages, 'ui.profile.address.form.state')
        }
    },
    postalCode: {
        identifier: 'zip',
        validations: {
            maxLength: 32
        },
        validationMessages: {
            maxLength: getMessage(messages, 'errors.com.epicgames.validation.max_length', [32])
        },
        display: {
            text: getMessage(messages, 'ui.profile.address.form.postalCode')
        }
    },
    state: {
        identifier: 'state',
        validationMessages: {
            isDefaultRequiredValue: getMessage(
                messages,
                'errors.com.epicgames.validation.required_field.v2'
            )
        },
        display: {
            text: getMessage(messages, 'label.affiliate.form.tax.state')
        }
    },
    w9form: {
        identifier: 'w9form',
        validations: {
            w9form: true
        },
        validationMessages: {
            w9form: getMessage(messages, 'errors.com.epicgames.validation.required_field.v2')
        },
        display: {
            text: getMessage(messages, 'ui.profile.tax.form.w9form')
        }
    }
});

export default getTaxSchema;
